"use strict";

import isTouchDevice from "./helper.isTouchDevice";

/**
 * Is the user device is a mobile or tablet
 * @return {Boolean} [description]
 */
export default function isMobileDevice() {
    return isTouchDevice() && window.matchMedia("(max-width: 1350px)").matches;
}
